export default __webpack_public_path__ + "static/media/steam.78d6b369.svg";